/*
 * Archie in the header search (Grass Mats Co).
 * - The live search panel (assets/gmc-nav.js; the element named by the input's aria-controls) gets an
 *   "Ask Archie" row on top of every set of results, and a bigger invitation when nothing matches.
 * - Questions typed into the search ("how many mats for a 3m x 6m drive?") open Archie instead of a results
 *   page; product searches ("23mm grass mats") still go to the normal search.
 * - The search bar's own mic button starts a spoken conversation with Archie.
 * - The search results page gets an Archie box under the heading (and a stronger one when nothing is found).
 * Loaded by snippets/archie.liquid after archie.js. Everything waits for window.ArchieChat.
 */
(function () {
  'use strict';
  var QUESTION = /^(how|what|whats|what's|which|why|when|where|who|can|could|do|does|did|is|are|should|will|would|i|im|i'm|my|we|our|help|need|recommend|best|tell|explain|advice|difference|compare)\b/i;

  function isQuestion(q) {
    q = (q || '').trim();
    if (!q) return false;
    if (q.indexOf('?') !== -1) return true;
    if (QUESTION.test(q)) return true;
    // Long phrases are usually a job description ("mats for my horse gateway it gets really muddy"),
    // short ones are product searches ("23mm grass mats").
    return q.split(/\s+/).length >= 7;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function archie() { return window.ArchieChat; }
  function ask(q, source, input) {
    var a = archie();
    if (!a) return false;
    closeDropdown(input);
    a.open(q, source);
    return true;
  }

  var forms = [].slice.call(document.querySelectorAll('form.gmc-search'));
  function inputOf(form) { return form.querySelector('input[name="q"]'); }
  function panelOf(input) { var id = input && input.getAttribute('aria-controls'); return id ? document.getElementById(id) : null; }

  function closeDropdown(input) {
    if (!input) return;
    input.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
    input.blur();
  }

  var SPARK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2l1.9 5.6L19.5 9.5l-5.6 1.9L12 17l-1.9-5.6L4.5 9.5l5.6-1.9zM19 14l.9 2.6 2.6.9-2.6.9L19 21l-.9-2.6-2.6-.9 2.6-.9z"/></svg>';
  var MIC = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10a7 7 0 0 0 14 0M12 17v5M8 22h8"/></svg>';

  // ---------- "Ask Archie" row in the search panel ----------
  function archieRow(q, none) {
    var title = none ? 'No exact match? Ask Archie' : 'Ask Archie: “' + esc(q) + '”';
    var sub = none ? 'Tell him the job and the area: he’ll pick the right mats and work out how many'
      : 'Our AI ground protection specialist picks the right product and quantity in seconds';
    return '<button type="button" class="archie-sr' + (none ? ' archie-sr--big' : '') + '" data-archie-sr="' + esc(q) + '">' +
      '<span class="archie-sr__av" aria-hidden="true">A</span>' +
      '<span class="archie-sr__txt"><b>' + title + '</b><small>' + sub + '</small></span>' +
      '<span class="archie-sr__go" aria-hidden="true">' + SPARK + '</span></button>';
  }
  function decorate(input) {
    var panel = panelOf(input), q = input.value.trim();
    if (!panel || !q || !panel.firstElementChild) return;
    var none = !!panel.querySelector('.gmc-search__empty');
    var row = panel.querySelector('.archie-sr');
    if (row && row.getAttribute('data-archie-sr') === q && row.classList.contains('archie-sr--big') === none) return;
    if (row) row.remove();
    panel.insertAdjacentHTML('afterbegin', archieRow(q, none));
  }
  forms.forEach(function (form) {
    var input = inputOf(form), panel = panelOf(input);
    if (!panel) return;
    var pending = 0;
    new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(function () { decorate(input); }, 30); })
      .observe(panel, { childList: true, subtree: true });
  });

  // Window capture: runs before any of the theme's own handlers.
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-archie-sr]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var q = b.getAttribute('data-archie-sr');
    if (b.classList.contains('archie-sr--big') && q) q = 'Find me the right product for: ' + q;
    var form = b.closest('form.gmc-search');
    ask(q || null, 'search_row', form ? inputOf(form) : null);
  }, true);

  // ---------- questions typed into the search open Archie ----------
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || forms.indexOf(form) < 0) return;
    var input = inputOf(form), q = input ? input.value.trim() : '';
    if (!isQuestion(q) || !archie()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'sn_specialist', sn_action: 'search_question', sn_source: 'archie' }); } catch (err) {}
    input.value = '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    ask(q, 'search_question', input);
  }, true);

  // ---------- the search bar's mic talks to Archie ----------
  function takeOverMics() {
    if (!archie() || !archie().talk) return;
    forms.forEach(function (form) {
      var mic = form.querySelector('.gmc-search__mic');
      if (!mic) return;
      mic.hidden = false; // Archie's voice works in every browser, not only those with built-in dictation
      mic.setAttribute('aria-label', 'Talk to Archie, our ground protection specialist');
      mic.setAttribute('title', 'Talk to Archie');
      mic.setAttribute('data-archie-mic', '');
    });
  }
  window.addEventListener('click', function (e) {
    var mic = e.target.closest && e.target.closest('[data-archie-mic]');
    if (!mic || !archie()) return;
    e.preventDefault();
    e.stopPropagation();
    var form = mic.closest('form.gmc-search');
    closeDropdown(form ? inputOf(form) : null);
    archie().talk('search_mic');
  }, true);

  // ---------- search results page ----------
  function searchPage() {
    if (!/^\/search\/?$/.test(location.pathname)) return;
    var q = new URLSearchParams(location.search).get('q');
    if (!q || document.querySelector('.archie-sp')) return;
    var h1 = document.querySelector('main h1');
    var host = h1 && (h1.closest('header, .page-header, .section__header, .page__header') || h1);
    if (!host) return;
    var none = !document.querySelector('main a[href*="/products/"]');
    var box = document.createElement('section');
    box.className = 'archie-sp' + (none ? ' archie-sp--none' : '');
    var lead = none ? 'No exact match for “' + esc(q) + '”, but Archie can help'
      : 'Not sure which of these is right for your job?';
    var chips = none ? ['Find me the right product for: ' + q, 'How many mats do I need?']
      : ['Which of these is best for my job?', 'How many do I need?', '16mm or 23mm?'];
    box.innerHTML = '<span class="archie-sp__av" aria-hidden="true">A</span><div class="archie-sp__body">' +
      '<b class="archie-sp__lead">' + lead + '</b>' +
      '<p>Ask Archie, our AI ground protection specialist. Tell him the job and the area and he’ll pick the right product and work out how many.</p>' +
      '<div class="archie-sp__chips">' + chips.map(function (c) {
        var full = c.indexOf(q) === -1 ? c + ' (I searched for “' + q + '”)' : c;
        return '<button type="button" class="archie-sp__chip" data-archie-sr="' + esc(full) + '">' + esc(c) + '</button>';
      }).join('') + '<button type="button" class="archie-sp__talk" data-archie-talk>' + MIC + 'Talk to Archie</button></div></div>';
    host.parentNode.insertBefore(box, host.nextSibling);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-archie-talk]');
    if (!t || !archie()) return;
    e.preventDefault();
    archie().talk('search_page');
  });

  function ready() { takeOverMics(); searchPage(); }
  // archie.js is deferred before this file, so ArchieChat exists by now; wait a moment if it doesn't.
  function start(tries) { if (archie() || tries > 40) ready(); else setTimeout(function () { start(tries + 1); }, 50); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(0); }); else start(0);
})();
